import { render, staticRenderFns } from "./InStoreAppointmentsTable.vue?vue&type=template&id=3f71d3a6"
import script from "./InStoreAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./InStoreAppointmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports